// extracted by mini-css-extract-plugin
export default {"row":"createCompetition_row__rgdR6","col":"createCompetition_col__kyav7","card":"createCompetition_card__3r8CZ"};